import { render, staticRenderFns } from "./TeacherPageBuilder.vue?vue&type=template&id=39a28528&scoped=true&"
import script from "./TeacherPageBuilder.vue?vue&type=script&lang=js&"
export * from "./TeacherPageBuilder.vue?vue&type=script&lang=js&"
import style0 from "./TeacherPageBuilder.vue?vue&type=style&index=0&id=39a28528&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a28528",
  null
  
)

component.options.__file = "TeacherPageBuilder.vue"
export default component.exports